import { Directive } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { ModalService } from '@common/services/modal.service';
import { TranslateService } from '@ngx-translate/core';
import { FormSafeNavigationService } from 'app/singleton-services/form-safe-navigation.service';
import { CommonController } from './common.controller';

@Directive()
export class FormBase extends CommonController {
    private _form: UntypedFormGroup;
    public get form(): UntypedFormGroup {
        return this._form;
    }
    public set form(v: UntypedFormGroup) {
        this._form = v;
        this.formSafeNavigation.addNewForm(this.form);
    }

    editMode = false;
    isBusy = true;

    constructor(
        dialogService: ModalService,
        translateService: TranslateService,
        protected formSafeNavigation: FormSafeNavigationService
    ) {
        super(dialogService, translateService);
    }
}
